export default __webpack_public_path__ + "static/main_image-b68b30430da5856c2f1c446b62e73d0a.jpg";